/**
 * 是否是添加卡片的操作组件
 */
export var isAdditionComponent = function (schema) {
    var _a, _b;
    return ((_b = (_a = schema['x-component']) === null || _a === void 0 ? void 0 : _a.indexOf) === null || _b === void 0 ? void 0 : _b.call(_a, 'Addition')) > -1;
};
